import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import { useState, useEffect } from 'react';
import Navigation from "./Navigation";
import TestComponent from "./TestComponent";
import Header from "./Header";

const TestPage = (props) => {
    let dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    return (<>
        <TestComponent />
        </>
    );
};

export default TestPage;